// Mirrors resources/assets/icons/newUi/duplicate.svg, which <x-copy-email/>
// inlines on the Blade surfaces — the two affordances must look identical.
const COPY_EMAIL_ICON_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<path d="M8.4001 10.7996C8.4001 9.47413 9.47461 8.39961 10.8001 8.39961H18.0001C19.3256 8.39961 20.4001 9.47413 20.4001 10.7996V17.9996C20.4001 19.3251 19.3256 20.3996 18.0001 20.3996H10.8001C9.47461 20.3996 8.4001 19.3251 8.4001 17.9996V10.7996Z" fill="#5C5E66"/>'
    + '<path d="M6.0001 3.59961C4.67461 3.59961 3.6001 4.67413 3.6001 5.99961V13.1996C3.6001 14.5251 4.67461 15.5996 6.0001 15.5996L6.0001 5.99961H15.6001C15.6001 4.67413 14.5256 3.59961 13.2001 3.59961H6.0001Z" fill="#5C5E66"/>'
    + '</svg>';

/**
 * Builds the copy control for client-side rendered email cells (DataTables,
 * legacy universal search). Blade surfaces use <x-copy-email/> instead.
 *
 * AC-2786: this one is safe by construction and must stay that way. The email
 * reaches `title` and `data-copy-email` through jQuery's attribute setter, and
 * the markup comes back out of `outerHTML`, so the browser does the attribute
 * escaping. Never rebuild this as a template string without escaping — the
 * value is a stored, unauthenticated-writable contact address.
 *
 * Extracted from app.js so it can be tested; app.js still publishes it on
 * window for the four call sites that read it there.
 *
 * jQuery is read off `window` rather than imported. webpack.mix.js declares no
 * .autoload()/externals/ProvidePlugin and every mix.js() is an independent
 * entry, so an `import $ from 'jquery'` here inlines a SECOND full copy of
 * jQuery (~88 KB) into every bundle that reaches this module — measured at
 * 156 KB for companies/show.js and 148 KB for contacts/index.js — and hands
 * this file a `$` with none of the page's plugins registered.
 * webpack.mix.js:133 documents the same hazard for leadAttributions/timeline.js.
 *
 * @param {string} email
 * @param {{copy?: string, copied?: string}} labels
 * @returns {string}
 */
export function renderCopyEmailIcon(email, labels = {}) {
    if (!email) return '';

    const $ = window.jQuery;

    return $('<i>', {
        class: 'js-copy-email',
        role: 'button',
        tabindex: 0,
        title: labels.copy || '',
        'data-copy-email': email,
        'data-copied-label': labels.copied || '',
    }).html(COPY_EMAIL_ICON_SVG).prop('outerHTML');
}
